/** Crypto quote currencies, longest first so `USDT` wins over `USD`. */
const CRYPTO_QUOTE_CURRENCIES = ["USDT", "USDC", "USD", "BTC", "ETH"] as const;

/**
 * Comparable form of a symbol: the watchlist stores crypto as a pair
 * (`BTC/USD`) while positions report it unslashed (`BTCUSD`).
 */
export const watchlistSymbolKey = (symbol: string): string =>
  symbol.trim().toUpperCase().replaceAll("/", "");

/**
 * Pair form of a crypto symbol, since watchlist market data routes on the
 * slash. Returns the symbol unchanged when no quote currency is recognisable.
 */
export const toWatchlistCryptoSymbol = (symbol: string): string => {
  const normalized = symbol.trim().toUpperCase();
  if (normalized.includes("/")) {
    return normalized;
  }
  const quote = CRYPTO_QUOTE_CURRENCIES.find(
    (candidate) =>
      normalized.length > candidate.length && normalized.endsWith(candidate),
  );
  return quote ? `${normalized.slice(0, -quote.length)}/${quote}` : normalized;
};
